import { FileOpener } from '@ionic-native/file-opener'
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem'

type Config = {
  path: string
  data: string
  directory: typeof Directory.Documents
  recursive: boolean
  encoding?: typeof Encoding.UTF8
}

export default async function handleMobileSaveFiles(data: string, fileName: string, type: string): Promise<void> {
  try {
    const config: Config = {
      path: `merinio/${fileName}`,
      data,
      directory: Directory.Documents,
      recursive: true
    }

    // If not base64, use utf8 encoding
    if (type !== 'application/pdf') config.encoding = Encoding.UTF8

    // Write the file to the app filesystem
    const result = await Filesystem.writeFile(config)

    // Open the file we just wrote
    FileOpener.showOpenWithDialog(`${result.uri}`, type)
  } catch (e) {
    console.error('Unable to write file', e)
  }
}
